var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./Pill.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-715b1154\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Pill.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Pill/Pill.vue.html
// module id = 7GAQ
// module chunks = 2